const __WEBPACK_NAMESPACE_OBJECT__ = require("@web3auth/base");